import * as actionTypes from './actionTypes'

export function updateBOLInfoField(field, payload) {
  return {
    type: actionTypes.UPDATE_BOL_INFO_FIELD,
    payload,
    field
  }
}
export function updateContainer(index, field, payload) {
  return {
    type: actionTypes.UPDATE_CONTAINER_FIELD,
    payload,
    field,
    index
  }
}

export function addContainer(newContainer) {
  return {
    type: actionTypes.ADD_CONTAINER,
    newContainer
  }
}

export function removeAdditionalContainer(index) {
  return {
    type: actionTypes.REMOVE_ADDITIONAL_CONTAINER,
    payload: index
  }
}
export function updateITDateField(payload) {
  return {
    type: actionTypes.UPDATE_IT_DATE_FIELD,
    payload
  }
}
export function saveBOLInfoField(field) {
  return {
    type: actionTypes.SAVE_BOL_FIELD,
    field
  }
}
export function saveBOLInfoObject(fieldc, objectX) {
  return {
    type: actionTypes.SAVE_BOL_OBJECT,
    fieldc,
    objectX
  }
}

export function saveBOLInfoDateField(field, payload) {
  return {
    type: actionTypes.SAVE_BOL_DATE_FIELD,
    payload,
    field
  }
}

export function saveContainer(index, field, payload) {
  return {
    type: actionTypes.SAVE_CONTAINER,
    index,
    field,
    payload
  }
}

export function updateBOLObject(object, field, payload) {
  return {
    type: actionTypes.UPDATE_BOL_OBJECT,
    payload,
    field,
    object
  }
}

export function updateBolErrorWarning(warnings) {
  return {
    type: actionTypes.UPDATE_BOL_INFO_WARNING,
    warnings
  }
}
